import { render, staticRenderFns } from "./faq-list.vue?vue&type=template&id=060aacda&scoped=true&"
import script from "./faq-list.vue?vue&type=script&lang=js&"
export * from "./faq-list.vue?vue&type=script&lang=js&"
import style0 from "./faq-list.vue?vue&type=style&index=0&id=060aacda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060aacda",
  null
  
)

export default component.exports